module.exports = __webpack_public_path__ + "img/like_active.8c0ad19c.png";